"use client"

import {
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Select,
  Stack,
  Switch,
  ModalCloseButton,
  ModalHeader,
  Box,
  SkeletonCircle,
  SkeletonText,
  Tooltip,
  Alert,
  AlertIcon,
  Text,
  Flex,
  useToast,
  ModalBody,
  SimpleGrid,
  ModalFooter,
  Badge,
} from "@chakra-ui/react"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from "react-hook-form"
import {
  addCandidateEducationAsync,
  deleteCandidateEducationAsync,
  fetchCandidateEducationAsync,
  selectCandidateEducation,
  updateCandidateEducationAsync,
} from "../../CandProfCreation/CandidateProfileSlice/Education/EducationSlice"
import {
  fetchJobEducationCourseAsync,
  selectJobEducationCourse,
} from "../../AdminPanel/JobPostingSlice/JobEducationCourse/JobEducationCourceSlice"
import {
  fetchJobEducationAsync,
  selectJobEducation,
} from "../../AdminPanel/JobPostingSlice/JobEducation/JobEducationSlice"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBuildingColumns } from "@fortawesome/free-solid-svg-icons"
import {
  fetchJobEducationCourseSpecialtyAsync,
  selectJobEducationCourseSpecialty,
} from "../../AdminPanel/JobPostingSlice/JobEducationCourseSpecialty/JobEducationCourseSpecialtySlice"
import EmptyState from "../../CandProfCreation/components/Tester"
import { FaGraduationCap } from "react-icons/fa"

export default function EducationshowPage() {
  const dispatch = useDispatch()
  const [selectedEducation, setSelectedEducation] = useState(null)
  const educationData = useSelector(selectCandidateEducation)
  const jobEducationCourse = useSelector(selectJobEducationCourse)
  const jobEducation = useSelector(selectJobEducation)
  const specialization = useSelector(selectJobEducationCourseSpecialty)
  const hasInitiatedFetch = useRef(false)
  const hasInitiatedDegreeFetch = useRef(false)
  const hasInitiatedCourseFetch = useRef(false)
  const hasInitiatedSpecialtyFetch = useRef(false)

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors, isSubmitting, touchedFields },
  } = useForm({
    mode: "onChange",
  })

  const [isSwitchOn, setIsSwitchOn] = useState(false)
  const [loading, setLoading] = useState(true)
  const [formError, setFormError] = useState("")

  const currentYear = new Date().getFullYear()
  const startYearOptions = Array.from({ length: 30 }, (_, i) => currentYear - i)
  const [startYear, setStartYear] = useState(null)

  const { isOpen: isOpen1, onOpen: onOpen1, onClose: onClose1 } = useDisclosure()
  const { isOpen: isOpen2, onOpen: onOpen2, onClose: onClose2 } = useDisclosure()
  const { isOpen: isOpen3, onOpen: onOpen3, onClose: onClose3 } = useDisclosure()

  const gradingSystem = watch("grading_system")

  const validateMarks = (value) => {
    if (!value) return "Marks are required"
    const numValue = Number.parseFloat(value)
    if (isNaN(numValue)) return "Please enter a valid number"
    if (gradingSystem === "CGPA") {
      if (numValue < 0 || numValue > 10) return "CGPA must be between 0 and 10"
    } else if (gradingSystem === "GPA") {
      if (numValue < 0 || numValue > 4) return "GPA must be between 0 and 4"
    } else if (gradingSystem === "Percentage") {
      if (numValue < 0 || numValue > 100) return "Percentage must be between 0 and 100"
    }
    return true
  }

  useEffect(() => {
    if (!hasInitiatedFetch.current && (!educationData || educationData.length === 0)) {
      hasInitiatedFetch.current = true
      dispatch(fetchCandidateEducationAsync())
      dispatch(fetchJobEducationAsync())
      setLoading(false)
    } else if (educationData && educationData.length > 0) {
      setLoading(false)
    }
  }, [dispatch, educationData])

  const [selectedDegreeUuid, setSelectedDegreeUuid] = useState("")
  const [selectedCourseUuid, setSelectedCourseUuid] = useState("")

  useEffect(() => {
    if (selectedDegreeUuid) {
      dispatch(fetchJobEducationCourseAsync(selectedDegreeUuid))
    }
  }, [selectedDegreeUuid, dispatch])

  useEffect(() => {
    if (selectedCourseUuid) {
      dispatch(fetchJobEducationCourseSpecialtyAsync(selectedCourseUuid))
    }
  }, [selectedCourseUuid, dispatch])

  const openUpdateModal = (education) => {
    setSelectedEducation(education)

    if (education.education?.uuid) {
      setSelectedDegreeUuid(education.education.uuid)
      setValue("education_uuid", education.education.uuid)
    } else {
      setSelectedDegreeUuid("")
      setValue("education_uuid", "")
    }

    if (education.education_course?.uuid) {
      setSelectedCourseUuid(education.education_course.uuid)
      setValue("course_uuid", education.education_course.uuid)
    } else {
      setSelectedCourseUuid("")
      setValue("course_uuid", "")
    }

    if (education.education_course_specialty?.uuid) {
      setValue("specialization_uuid", education.education_course_specialty.uuid)
    } else {
      setValue("specialization_uuid", "")
    }

    if (education.course_duration_start_year) {
      setStartYear(Number(education.course_duration_start_year))
    } else {
      setStartYear(null)
    }

    setIsSwitchOn(!!education.primary_education)

    setValue("insitute_university", education.insitute_university)
    setValue("university_name", education.university_name)
    setValue("course_type", education.course_type)
    setValue("marks", education.marks)
    setValue("grading_system", education.grading_system)
    setValue("course_duration_start_year", education.course_duration_start_year)
    setValue("course_duration_end_year", education.course_duration_end_year)
    setValue("primary_education", education.primary_education)

    onOpen2()
  }

  useEffect(() => {
    if (isOpen1) {
      reset()
      setSelectedDegreeUuid("")
      setSelectedCourseUuid("")
      setIsSwitchOn(false)
      setFormError("")
    }
  }, [reset, isOpen1])

  const [deletingEducation, setDeletingEducation] = useState(null)
  const toast = useToast()

  const handleSave = async (newCandidateEducation) => {
    setFormError("")
    try {
      const response = await dispatch(addCandidateEducationAsync({ newCandidateEducation }))
      if (response?.payload?.status === "success") {
        await dispatch(fetchCandidateEducationAsync())
        onClose1()
        reset()
        toast({
          title: "Education Added",
          description: "Education has been successfully added.",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        })
      } else {
        setFormError("Failed to add education. Please check your information and try again.")
        toast({
          title: "Error",
          description: "Failed to add education. Please check your information and try again.",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        })
      }
    } catch (error) {
      const errorMessage = error.message || "An error occurred while adding education"
      setFormError(errorMessage)
      console.error("Failed to add education", error)
      toast({
        title: "Error",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      })
    }
  }

  const handleUpdate = async (CandidateEducationData) => {
    setFormError("")
    if (selectedEducation) {
      try {
        const response = await dispatch(
          updateCandidateEducationAsync({
            uuid: selectedEducation.uuid,
            CandidateEducationData: CandidateEducationData,
          }),
        )
        if (response?.payload?.status === "success") {
          await dispatch(fetchCandidateEducationAsync())
          setSelectedEducation(null)
          reset()
          onClose2()
          toast({
            title: "Education Updated",
            description: "Education details have been successfully updated.",
            status: "success",
            duration: 3000,
            isClosable: true,
            position: "top-right",
          })
        } else {
          setFormError("Failed to update education. Please check your information and try again.")
          toast({
            title: "Error",
            description: "Failed to update education. Please check your information and try again.",
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "top-right",
          })
        }
      } catch (error) {
        const errorMessage = error.message || "An error occurred while updating education"
        setFormError(errorMessage)
        console.error("Failed to update education", error)
        toast({
          title: "Error",
          description: errorMessage,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        })
      }
    }
  }

  const handleDelete = async (uuid) => {
    try {
      const response = await dispatch(deleteCandidateEducationAsync({ uuid }))
      await dispatch(fetchCandidateEducationAsync())
      reset()
      onClose3()
      toast({
        title: "Education Deleted",
        description: "Education has been successfully removed.",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      })
    } catch (error) {
      console.error("Failed to delete education", error)
      toast({
        title: "Error",
        description: error.message || "An error occurred while deleting education",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      })
    }
  }

  const openDeleteModal = (education) => {
    setDeletingEducation(education)
    dispatch(fetchCandidateEducationAsync())
    onOpen3()
  }

  const selectedStartYear = watch("course_duration_start_year", startYear)
  const startYears = Array.from({ length: currentYear - 1975 + 1 }, (_, i) => 1975 + i)
  const endYears = Array.from({ length: 2030 - 1975 + 1 }, (_, i) => 1975 + i).filter(
    (year) => year >= selectedStartYear,
  )

  return (
    <div className="">
      <div className="bg-mainBg " style={{ fontFamily: "Inter, sans-serif" }}>
        <div className=" mx-auto ">
          <div className="bg-white rounded-xl w-full px-3 sm:px-5 py-4 shadow-sm  border-gray-100">
            {/* Header */}
            <div className="flex sm:flex-row sm:items-center justify-between gap-3 mb-3">
              <div className="flex items-start gap-2">
                <div className="h-9 w-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center">
                  <FaGraduationCap />
                </div>
                <div>
                  <h1 className="text-xl sm:text-2xl md:text-3xl text-left font-semibold">Education</h1>
                  <p className="text-xs text-gray-500">Add and manage your academic qualifications</p>
                </div>
              </div>
              <div className="flex gap-2">
                <Tooltip label="Add new education" aria-label="Add education tooltip">
                  <Button
                    colorScheme="blue"
                    size="md"
                    fontSize="md"
                    onClick={onOpen1}
                    className="whitespace-nowrap shadow"
                  >
                    Add <i className="fa-solid fa-plus pl-2"></i>
                  </Button>
                </Tooltip>
              </div>
            </div>

            {/* Content */}
            <div className="space-y-3">
              {loading ? (
                <>
                  <Box className="border p-4 sm:p-5 bg-white shadow-sm rounded-lg">
                    <SkeletonCircle size="14" mb="4" />
                    <SkeletonText noOfLines={4} spacing="3" skeletonHeight="3" />
                  </Box>
                  <Box className="border p-4 sm:p-5 bg-white shadow-sm rounded-lg">
                    <SkeletonCircle size="14" mb="4" />
                    <SkeletonText noOfLines={4} spacing="3" skeletonHeight="3" />
                  </Box>
                </>
              ) : Array.isArray(educationData) && educationData.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-6">
                  <EmptyState
                    title="Education"
                    icon={FaGraduationCap}
                    emptyMessage="Start by adding your Education"
                    addButtonText="Add Your Education"
                    onAdd={onOpen1}
                  />
                </div>
              ) : (
                educationData?.map((education, index) => (
                  <div
                    key={index}
                    className="group relative border rounded-xl shadow-sm hover:shadow-md transition-all duration-200 bg-white overflow-hidden"
                  >
                    {/* Accent bar */}
                    <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-blue-500 to-indigo-500" />

                    <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 md:p-5 gap-4">
                      <div className="flex items-start gap-3 min-w-0">
                        <div className="h-12 w-12 sm:h-12 sm:w-12 md:h-14 md:w-14 flex-shrink-0 rounded-full border flex justify-center items-center bg-gray-50 text-blue-500">
                          <FontAwesomeIcon icon={faBuildingColumns} size="lg" />
                        </div>
                        <div className="min-w-0 flex-1">
                          <div className="flex items-center gap-2 flex-wrap">
                            <div className="text-base sm:text-lg font-semibold text-gray-900 leading-tight break-words">
                              {education.insitute_university}
                              {education.university_name && `, ${education.university_name}`}
                            </div>
                            {education.primary_education ? (
                              <Badge colorScheme="green" variant="subtle" className="rounded-full">
                                Primary
                              </Badge>
                            ) : null}
                          </div>

                          <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1 text-sm text-gray-600">
                            {education.education?.title && (
                              <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-0.5 text-gray-700">
                                {education.education.title}
                              </span>
                            )}
                            {education.education_course?.title && (
                              <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-0.5 text-gray-700">
                                {education.education_course.title}
                              </span>
                            )}
                            {education.education_course_specialty?.title && (
                              <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-0.5 text-gray-700">
                                {education.education_course_specialty.title}
                              </span>
                            )}
                            {education.course_type && (
                              <span className="inline-flex items-center rounded-md bg-amber-50 px-2 py-0.5 text-amber-700">
                                {education.course_type}
                              </span>
                            )}
                          </div>

                          <div className="mt-1 flex flex-wrap items-center gap-3 text-xs sm:text-sm text-gray-500">
                            <span>
                              {education.course_duration_start_year} - {education.course_duration_end_year}
                            </span>
                            {education.marks && (
                              <span className="inline-flex items-center gap-1 text-gray-600">
                                <span className="h-1.5 w-1.5 rounded-full bg-gray-300"></span>
                                {education.grading_system}: <strong className="text-gray-800">{education.marks}</strong>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex gap-2 self-end sm:self-center ml-auto sm:ml-0">
                        <Tooltip label="Edit education">
                          <Button
                            fontSize="sm"
                            onClick={() => openUpdateModal(education)}
                            colorScheme="blue"
                            variant="solid"
                            className="min-w-8 h-8 sm:min-w-10 sm:h-10 shadow-sm"
                          >
                            <i className="fa-sharp fa-solid fa-pen"></i>
                          </Button>
                        </Tooltip>
                        <Tooltip label="Delete education">
                          <Button
                            onClick={() => openDeleteModal(education)}
                            colorScheme="red"
                            variant="outline"
                            className="min-w-8 h-8 sm:min-w-10 sm:h-10"
                          >
                            <i className="cursor-pointer fa-solid fa-trash"></i>
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        {/* Add Education Modal */}
        <Modal isOpen={isOpen1} onClose={onClose1} maxW="3xl" isCentered>
          <ModalOverlay />
          <ModalContent maxW={"5xl"}>
            <form onSubmit={handleSubmit(handleSave)}>
              <ModalHeader>
                <div className="flex items-center gap-2">
                  <div className="h-8 w-8 rounded-md bg-blue-50 text-blue-600 flex items-center justify-center">
                    <FaGraduationCap />
                  </div>
                  <span>Add Education</span>
                </div>
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                {formError && (
                  <Alert status="error" mb={4} borderRadius="md" variant="left-accent">
                    <AlertIcon />
                    {formError}
                  </Alert>
                )}

                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                  {/* Degree Select */}
                  <FormControl isInvalid={!!errors.education_uuid} isRequired>
                    <FormLabel>Degree</FormLabel>
                    <Select
                      placeholder="Select Degree"
                      {...register("education_uuid", {
                        required: "Degree is required",
                      })}
                      value={selectedDegreeUuid}
                      onChange={(e) => setSelectedDegreeUuid(e.target.value)}
                    >
                      {Array.isArray(jobEducation) &&
                        jobEducation.map((job) => (
                          <option key={job.id} value={job.uuid}>
                            {job.title}
                          </option>
                        ))}
                    </Select>
                    <FormErrorMessage>{errors.education_uuid && errors.education_uuid.message}</FormErrorMessage>
                  </FormControl>

                  {/* Course Select */}
                  <FormControl isInvalid={!!errors.course_uuid} isRequired>
                    <FormLabel>Education Course</FormLabel>
                    {Array.isArray(jobEducationCourse) && jobEducationCourse.length > 0 ? (
                      <Select
                        placeholder="Select Course"
                        {...register("course_uuid", {
                          required: "Education Course is required",
                        })}
                        value={selectedCourseUuid}
                        onChange={(e) => setSelectedCourseUuid(e.target.value)}
                        isDisabled={!selectedDegreeUuid}
                      >
                        {jobEducationCourse.map((course) => (
                          <option key={course.uuid} value={course.uuid}>
                            {course.title}
                          </option>
                        ))}
                      </Select>
                    ) : (
                      <Text color="gray.500" py={2} px={3} borderWidth="1px" borderRadius="md">
                        No Courses Available for Selected Field
                      </Text>
                    )}
                    <FormErrorMessage>{errors.course_uuid && errors.course_uuid.message}</FormErrorMessage>
                    {!selectedDegreeUuid && touchedFields.course_uuid && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        Please select a degree first
                      </Text>
                    )}
                  </FormControl>

                  {/* Specialization Select */}
                  <FormControl isInvalid={!!errors.specialization_uuid}>
                    <FormLabel>Specialization</FormLabel>
                    {Array.isArray(specialization) && specialization.length > 0 ? (
                      <Select
                        placeholder="Select Specialization"
                        {...register("specialization_uuid")}
                        isDisabled={!selectedCourseUuid}
                      >
                        {specialization.map((specialty) => (
                          <option key={specialty.uuid} value={specialty.uuid}>
                            {specialty.title}
                          </option>
                        ))}
                      </Select>
                    ) : (
                      <Text color="gray.500" py={2} px={3} borderWidth="1px" borderRadius="md">
                        No Specializations Available for Selected Course
                      </Text>
                    )}
                    <FormErrorMessage>{errors.specialization_uuid && errors.specialization_uuid.message}</FormErrorMessage>
                    {!selectedCourseUuid && touchedFields.specialization_uuid && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        Please select a course first
                      </Text>
                    )}
                  </FormControl>

                  {/* Course Type */}
                  <FormControl isInvalid={!!errors.course_type} isRequired>
                    <FormLabel>Course Type</FormLabel>
                    <Select
                      placeholder="Select Course Type"
                      {...register("course_type", {
                        required: "Course type is required",
                      })}
                      defaultValue="Full Time"
                    >
                      <option value="Full Time">Full Time</option>
                      <option value="Part Time">Part Time</option>
                      <option value="Diploma">Diploma</option>
                      {/* <option value="Dummy">Dummy</option> */}
                    </Select>
                    <FormErrorMessage>{errors.course_type && errors.course_type.message}</FormErrorMessage>
                  </FormControl>

                  {/* Institute Name */}
                  <FormControl isInvalid={!!errors.insitute_university} isRequired>
                    <FormLabel>Institute Name</FormLabel>
                    <Input
                      type="text"
                      {...register("insitute_university", {
                        required: "Institute name is required",
                        minLength: {
                          value: 3,
                          message: "Institute name must be at least 3 characters",
                        },
                        onChange: () => (touchedFields.insitute_university = true),
                      })}
                      placeholder="Enter Institute Name"
                    />
                    <FormErrorMessage>{errors.insitute_university && errors.insitute_university.message}</FormErrorMessage>
                  </FormControl>

                  {/* University Name */}
                  <FormControl isInvalid={!!errors.university_name} isRequired>
                    <FormLabel>University Name</FormLabel>
                    <Input
                      type="text"
                      {...register("university_name", {
                        required: "University name is required",
                        minLength: {
                          value: 3,
                          message: "Institute name must be at least 3 characters",
                        },
                        onChange: () => (touchedFields.university_name = true),
                      })}
                      placeholder="Enter University Name"
                    />
                    <FormErrorMessage>{errors.university_name && errors.university_name.message}</FormErrorMessage>
                  </FormControl>

                  {/* Grading System */}
                  <FormControl isInvalid={!!errors.grading_system} isRequired>
                    <FormLabel>Grading System</FormLabel>
                    <Select
                      placeholder="Select option"
                      {...register("grading_system", {
                        required: "Grading system is required",
                      })}
                      onChange={(e) => {
                        setValue("grading_system", e.target.value)
                        setValue("marks", "")
                      }}
                    >
                      <option value="CGPA">CGPA</option>
                      <option value="Percentage">Percentage</option>
                      <option value="GPA">GPA</option>
                    </Select>
                    <FormErrorMessage>{errors.grading_system && errors.grading_system.message}</FormErrorMessage>
                  </FormControl>

                  {/* Marks */}
                  <FormControl isInvalid={!!errors.marks} isRequired>
                    <FormLabel>Your Score</FormLabel>
                    <Input
                      type="text"
                      {...register("marks", {
                        required: "Marks are required",
                        validate: validateMarks,
                      })}
                      placeholder={
                        gradingSystem === "CGPA"
                          ? "Enter CGPA (0-10)"
                          : gradingSystem === "GPA"
                            ? "Enter GPA (0-4)"
                            : gradingSystem === "Percentage"
                              ? "Enter Percentage (0-100)"
                              : "Enter your score"
                      }
                    />
                    <FormErrorMessage>{errors.marks && errors.marks.message}</FormErrorMessage>
                    {!watch("grading_system") && touchedFields.marks && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        Please select a grading system first
                      </Text>
                    )}
                  </FormControl>

                  {/* Course Duration - Start Year */}
                  <FormControl isInvalid={!!errors.course_duration_start_year} isRequired>
                    <FormLabel>Starting Year</FormLabel>
                    <Select
                      placeholder="Select Starting Year"
                      {...register("course_duration_start_year", {
                        required: "Starting year is required",
                      })}
                      onChange={(e) => {
                        const newStartYear = Number(e.target.value)
                        setStartYear(newStartYear)
                        setValue("course_duration_start_year", newStartYear)
                        const currentEndYear = watch("course_duration_end_year")
                        if (currentEndYear < newStartYear) {
                          setValue("course_duration_end_year", newStartYear)
                        }
                      }}
                    >
                      {startYears.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage>
                      {errors.course_duration_start_year && errors.course_duration_start_year.message}
                    </FormErrorMessage>
                  </FormControl>

                  {/* Course Duration - End Year */}
                  <FormControl isInvalid={!!errors.course_duration_end_year} isRequired>
                    <FormLabel>Completion Year</FormLabel>
                    <Select
                      placeholder="Select Completion Year"
                      {...register("course_duration_end_year", {
                        required: "Completion year is required",
                        validate: (value) =>
                          Number.parseInt(value) >= Number.parseInt(watch("course_duration_start_year")) ||
                          "Completion year must be after or equal to starting year",
                      })}
                    >
                      {endYears.length > 0 ? (
                        endYears.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))
                      ) : (
                        <option value="">Select start year first</option>
                      )}
                    </Select>
                    <FormErrorMessage>
                      {errors.course_duration_end_year && errors.course_duration_end_year.message}
                    </FormErrorMessage>
                  </FormControl>

                  {/* Primary Education Toggle */}
                  <FormControl>
                    <Stack direction="row" alignItems="center">
                      <FormLabel mb={0}>Is this your primary education?</FormLabel>
                      <Switch
                        colorScheme="blue"
                        {...register("primary_education")}
                        isChecked={isSwitchOn}
                        onChange={(e) => setIsSwitchOn(e.target.checked)}
                      />
                    </Stack>
                  </FormControl>
                </SimpleGrid>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="blue" mr={3} type="submit" isLoading={isSubmitting} loadingText="Saving">
                  Save
                </Button>
                <Button
                  onClick={() => {
                    reset()
                    onClose1()
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>

        {/* Edit Education Modal */}
        <Modal isOpen={isOpen2} onClose={onClose2} maxW="3xl" isCentered closeOnOverlayClick={false}>
          <ModalOverlay />
          <ModalContent maxW="5xl">
            <form onSubmit={handleSubmit(handleUpdate)}>
              <ModalHeader>
                <div className="flex items-center gap-2">
                  <div className="h-8 w-8 rounded-md bg-blue-50 text-blue-600 flex items-center justify-center">
                    <FaGraduationCap />
                  </div>
                  <span>Edit Education</span>
                </div>
              </ModalHeader>
              <ModalCloseButton
                onClick={() => {
                  reset()
                  onClose2()
                }}
              />
              <ModalBody pb={6}>
                {formError && (
                  <Alert status="error" mb={4} borderRadius="md" variant="left-accent">
                    <AlertIcon />
                    {formError}
                  </Alert>
                )}

                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                  {/* Degree Select */}
                  <FormControl isInvalid={!!errors.education_uuid} isRequired>
                    <FormLabel>Degree</FormLabel>
                    <Select
                      placeholder="Select Degree"
                      {...register("education_uuid", {
                        required: "Degree is required",
                      })}
                      value={selectedDegreeUuid}
                      onChange={(e) => {
                        const selectedValue = e.target.value
                        setSelectedDegreeUuid(selectedValue)
                        setValue("education_uuid", selectedValue)
                        setSelectedCourseUuid("")
                        setValue("course_uuid", "")
                        setValue("specialization_uuid", "")
                      }}
                    >
                      {Array.isArray(jobEducation) &&
                        jobEducation?.map((degree) => (
                          <option key={degree.uuid} value={degree.uuid}>
                            {degree.title}
                          </option>
                        ))}
                    </Select>
                    <FormErrorMessage>{errors.education_uuid && errors.education_uuid.message}</FormErrorMessage>
                  </FormControl>

                  {/* Course Select */}
                  <FormControl isInvalid={!!errors.course_uuid} isRequired>
                    <FormLabel>Education Course</FormLabel>
                    <Select
                      placeholder="Select Course"
                      {...register("course_uuid", {
                        required: "Education Course is required",
                      })}
                      value={selectedCourseUuid}
                      onChange={(e) => {
                        const courseValue = e.target.value
                        setSelectedCourseUuid(courseValue)
                        setValue("course_uuid", courseValue)
                        setValue("specialization_uuid", "")
                      }}
                      isDisabled={!selectedDegreeUuid}
                    >
                      {Array.isArray(jobEducationCourse) &&
                        jobEducationCourse.map((course) => (
                          <option key={course.uuid} value={course.uuid}>
                            {course.title}
                          </option>
                        ))}
                    </Select>
                    <FormErrorMessage>{errors.course_uuid && errors.course_uuid.message}</FormErrorMessage>
                    {!selectedDegreeUuid && touchedFields.course_uuid && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        Please select a degree first
                      </Text>
                    )}
                  </FormControl>

                  {/* Specialization Select */}
                  <FormControl isInvalid={!!errors.specialization_uuid}>
                    <FormLabel>Specialization</FormLabel>
                    <Select
                      placeholder="Select Specialization"
                      {...register("specialization_uuid")}
                      isDisabled={!selectedCourseUuid}
                    >
                      {Array.isArray(specialization) &&
                        specialization?.map((specialty) => (
                          <option key={specialty.uuid} value={specialty.uuid}>
                            {specialty.title}
                          </option>
                        ))}
                    </Select>
                    <FormErrorMessage>
                      {errors.specialization_uuid && errors.specialization_uuid.message}
                    </FormErrorMessage>
                    {!selectedCourseUuid && touchedFields.specialization_uuid && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        Please select a course first
                      </Text>
                    )}
                  </FormControl>

                  {/* Institute Name */}
                  <FormControl isInvalid={!!errors.insitute_university} isRequired>
                    <FormLabel>Institute Name</FormLabel>
                    <Input
                      type="text"
                      {...register("insitute_university", {
                        required: "Institute name is required",
                        minLength: {
                          value: 3,
                          message: "Institute name must be at least 3 characters",
                        },
                        onChange: () => (touchedFields.insitute_university = true),
                      })}
                      placeholder="Enter Institute Name"
                    />
                    <FormErrorMessage>
                      {errors.insitute_university && errors.insitute_university.message}
                    </FormErrorMessage>
                  </FormControl>

                  {/* University Name */}
                  <FormControl isInvalid={!!errors.university_name} isRequired>
                    <FormLabel>University Name</FormLabel>
                    <Input
                      type="text"
                      {...register("university_name", {
                        required: "University name is required",
                        minLength: {
                          value: 3,
                          message: "University name must be at least 3 characters",
                        },
                        onChange: () => (touchedFields.university_name = true),
                      })}
                      placeholder="Enter University Name"
                    />
                    <FormErrorMessage>
                      {errors.university_name && errors.university_name.message}
                    </FormErrorMessage>
                  </FormControl>

                  {/* Course Type */}
                  <FormControl isInvalid={!!errors.course_type} isRequired>
                    <FormLabel>Course Type</FormLabel>
                    <Select
                      placeholder="Select Course Type"
                      {...register("course_type", {
                        required: "Course type is required",
                      })}
                    >
                      <option value="Full Time">Full Time</option>
                      <option value="Part Time">Part Time</option>
                      <option value="Dummy">Dummy</option>
                    </Select>
                    <FormErrorMessage>{errors.course_type && errors.course_type.message}</FormErrorMessage>
                  </FormControl>

                  {/* Grading System */}
                  <FormControl isInvalid={!!errors.grading_system} isRequired>
                    <FormLabel>Grading System</FormLabel>
                    <Select
                      placeholder="Select option"
                      {...register("grading_system", {
                        required: "Grading system is required",
                      })}
                      onChange={(e) => {
                        setValue("grading_system", e.target.value)
                        setValue("marks", "")
                      }}
                    >
                      <option value="CGPA">CGPA</option>
                      <option value="Percentage">Percentage</option>
                      <option value="GPA">GPA</option>
                    </Select>
                    <FormErrorMessage>{errors.grading_system && errors.grading_system.message}</FormErrorMessage>
                  </FormControl>

                  {/* Marks */}
                  <FormControl isInvalid={!!errors.marks} isRequired>
                    <FormLabel>Your Score</FormLabel>
                    <Input
                      type="text"
                      {...register("marks", {
                        required: "Marks are required",
                        validate: validateMarks,
                      })}
                      placeholder={
                        gradingSystem === "CGPA"
                          ? "Enter CGPA (0-10)"
                          : gradingSystem === "GPA"
                            ? "Enter GPA (0-4)"
                            : gradingSystem === "Percentage"
                              ? "Enter Percentage (0-100)"
                              : "Enter your score"
                      }
                    />
                    <FormErrorMessage>{errors.marks && errors.marks.message}</FormErrorMessage>
                    {!watch("grading_system") && touchedFields.marks && (
                      <Text color="red.500" fontSize="sm" mt={1}>
                        Please select a grading system first
                      </Text>
                    )}
                  </FormControl>

                  {/* Course Duration - Start Year */}
                  <FormControl isInvalid={!!errors.course_duration_start_year} isRequired>
                    <FormLabel>Starting Year</FormLabel>
                    <Select
                      placeholder="Select Starting Year"
                      {...register("course_duration_start_year", {
                        required: "Starting year is required",
                      })}
                      onChange={(e) => {
                        const newYear = Number(e.target.value)
                        setStartYear(newYear)
                        const currentEndYear = watch("course_duration_end_year")
                        if (currentEndYear < newYear) {
                          setValue("course_duration_end_year", newYear.toString())
                        }
                      }}
                    >
                      {startYears.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage>
                      {errors.course_duration_start_year && errors.course_duration_start_year.message}
                    </FormErrorMessage>
                  </FormControl>

                  {/* Course Duration - End Year */}
                  <FormControl isInvalid={!!errors.course_duration_end_year} isRequired>
                    <FormLabel>Completion Year</FormLabel>
                    <Select
                      placeholder="Select Completion Year"
                      {...register("course_duration_end_year", {
                        required: "Completion year is required",
                        validate: (value) =>
                          Number.parseInt(value) >= Number.parseInt(watch("course_duration_start_year")) ||
                          "Completion year must be after or equal to starting year",
                      })}
                    >
                      {endYears.length > 0 ? (
                        endYears.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))
                      ) : (
                        <option value="">Select start year first</option>
                      )}
                    </Select>
                    <FormErrorMessage>
                      {errors.course_duration_end_year && errors.course_duration_end_year.message}
                    </FormErrorMessage>
                  </FormControl>

                  {/* Primary Education Toggle */}
                  <FormControl>
                    <Stack direction="row" alignItems="center">
                      <FormLabel mb={0}>Is this your primary education?</FormLabel>
                      <Switch
                        colorScheme="blue"
                        {...register("primary_education")}
                        isChecked={watch("primary_education")}
                        onChange={(e) => setValue("primary_education", e.target.checked)}
                      />
                    </Stack>
                  </FormControl>
                </SimpleGrid>

                {/* Validation Summary */}
                {Object.keys(errors).length > 0 && (
                  <Alert status="error" mt={6} borderRadius="md" variant="left-accent">
                    <AlertIcon />
                    <Box>
                      <Text fontWeight="bold">Please correct the following errors:</Text>
                      <Box as="ul" pl={5} mt={2} styleType="disc">
                        {errors.education_uuid && (
                          <Box as="li" color="red.500">
                            {errors.education_uuid.message || "Select a degree"}
                          </Box>
                        )}
                        {errors.course_uuid && (
                          <Box as="li" color="red.500">
                            {errors.course_uuid.message || "Select an education course"}
                          </Box>
                        )}
                        {errors.specialization_uuid && (
                          <Box as="li" color="red.500">
                            {errors.specialization_uuid.message || "Select a specialization"}
                          </Box>
                        )}
                        {errors.insitute_university && (
                          <Box as="li" color="red.500">
                            {errors.insitute_university.message || "Enter institute name"}
                          </Box>
                        )}
                        {errors.university_name && (
                          <Box as="li" color="red.500">
                            {errors.university_name.message || "Enter University name"}
                          </Box>
                        )}
                        {errors.course_type && (
                          <Box as="li" color="red.500">
                            {errors.course_type.message || "Select course type"}
                          </Box>
                        )}
                        {errors.grading_system && (
                          <Box as="li" color="red.500">
                            {errors.grading_system.message || "Select grading system"}
                          </Box>
                        )}
                        {errors.marks && (
                          <Box as="li" color="red.500">
                            {errors.marks.message || "Enter valid marks"}
                          </Box>
                        )}
                        {errors.course_duration_start_year && (
                          <Box as="li" color="red.500">
                            {errors.course_duration_start_year.message || "Select starting year"}
                          </Box>
                        )}
                        {errors.course_duration_end_year && (
                          <Box as="li" color="red.500">
                            {errors.course_duration_end_year.message || "Select completion year"}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Alert>
                )}
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="blue" mr={3} type="submit" isLoading={isSubmitting} loadingText="Updating">
                  Update
                </Button>
                <Button
                  onClick={() => {
                    reset()
                    onClose2()
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal isOpen={isOpen3} onClose={onClose3}>
          <ModalOverlay />
          <ModalContent p={3}>
            <ModalHeader>Delete Education</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Alert status="warning" mb={3} borderRadius="md" variant="left-accent">
                <AlertIcon />
                This action cannot be undone.
              </Alert>
              <p className="text-sm text-gray-700">
                Are you sure you want to delete{" "}
                <span className="font-semibold">{deletingEducation?.insitute_university}</span> education?
              </p>
              <div className="flex justify-end gap-2 mt-4">
                <Button colorScheme="red" onClick={() => handleDelete(deletingEducation?.uuid)}>
                  Delete
                </Button>
                <Button variant="outline" onClick={onClose3}>
                  Cancel
                </Button>
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </div>
  )
}